<template>
  <div>
    <div class="common-header">
    <div>
      <el-button type="primary" @click="showEditFunc()">新增特权</el-button>
    </div>
    <div class="common-header-right">
      <div class="common-header-block">
      </div>
      <div class="common-header-block">
        <el-input
            class="common-el-input"
            placeholder="输入用户ID查询"
            v-model="searchVal">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" @click="getList()">搜索</el-button>
      </div>
    </div>
    </div>
    <div class="common-table">
      <el-table
          v-loading="loading"
          :data="privilegeUsers"
          row-key="id"
          height="100%">
        <el-table-column align="center" label="编号" type="index"/>
        <el-table-column align="center" label="用户id" prop="userId"/>
        <el-table-column align="center" label="用户昵称" prop="userName"/>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="removeFunc(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
        class="common-el-pagination"
        layout="prev,pager,next,jumper"
        background
        :page-size="10"
        :pager-count="5"
        :total="total"
        :current-page="currentPage"
        @current-change="getList({page:$event})"/>
    <div v-show="show" class="common-popup-bg">
      <div class="common-popup">
        <h3>新增特殊用户</h3>
        <el-form ref="privilrgrUser"
                 class="common-popup-table"
                 label-width="100px"
                 :model="form"
                 :rules="rules"
        >
          <el-form-item label="用户ID:"
                        prop="userId">
            <el-input type="number" resize="none" v-model="form.userId" style="width: 240px" placeholder="请输入用户Id"/>
          </el-form-item>
        </el-form>
        <footer>
          <el-button type="small" @click="close('privilrgrUser')">取消</el-button>
          <el-button type="primary" size="small" @click="submitForm('privilrgrUser')">确认</el-button>
        </footer>
      </div>
    </div>
  </div>

</template>
<script>
import {mapActions, mapState} from 'vuex'

export default {
  data() {
    return {
      loading: false,
      show: false,
      searchVal:null,
      privilegeUsers:[],
      total:0,
      currentPage:0,
      form:{
        userId:null
      },
      rules: {
        userId: [
          {required: true, message: '请输入用户Id', trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    ...mapState('login', ['permissions']),
    ...mapActions('user', ['queryPrivilegeUser', 'addPrivilegeUser', 'deletePrivilegeUser']),
    getList(page = 1) {
      this.loading = true;
      this.queryPrivilegeUser({
        userId: this.searchVal,
        page
      }).then(res => {
        this.loading = false;
        this.privilegeUsers=res.data.privilegeUsers;
        this.total=res.data.total;
      })
    },
    showEditFunc() {
      this.show = true;
    },
    btntest(id){
      console.log(id)
    },
    removeFunc(row) {
      this.$confirm(`是否确认删除"${row.userName}"？删除后该特殊玩家无法控制发牌。`, '删除特殊玩家权限', {
        type: 'info'
      }).then(() => {
        this.deletePrivilegeUser({
          userId:row.userId
        }).then(() => {
          this.getList();
        })
      }).catch(()=>{})
    },
    submitForm(formName) {
      console.log(formName)
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          let {...params}=this.form;
          console.log(params)
          this.addPrivilegeUser(params).then(() => {
            this.show = false;
            this.$message.success('添加成功');
            this.getList();
            this.close(formName)
          }).catch((res)=>{
            this.$message.error(res.data)
          })
        }
      })
    },
    close(formName) {
      this.$refs[formName].resetFields();
      this.show = false;
    }
  }
}
</script>
<style lang="scss" scoped>
.text1 {
  padding: 0 0 10px 20px;
  font-size: 14px;
  color: #999;
}
</style>